import AppRouting from '../routing/AppRouting';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  ThemeOptions,
} from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../data/store';
import { LicenseInfo } from '@mui/x-license-pro';

const { __environment__ } = window as any;
const dataGripProKey = __environment__.REACT_APP_DATA_GRID_PRO_KEY;

LicenseInfo.setLicenseKey(dataGripProKey);

const App = () => {
  const secondary = '#fff';
  const primary = '#197CB3';

  const themeColors: ThemeOptions = {
    palette: {
      mode: 'light',
      primary: {
        main: primary,
      },
      secondary: {
        main: secondary,
      },
      info: {
        main: '#6c6d6e',
      },
    },
  };

  let theme = createTheme(themeColors);
  theme = createTheme(theme, {
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 400,
            fontSize: 14,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            fontSize: 15,
            textTransform: 'unset',
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            fontFamily: 'Source Sans Pro',
          },
        },
      },
    },
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Provider store={store}>
            <AppRouting />
          </Provider>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
